module.exports = __webpack_public_path__ + "img/mobile/IntroPopups/confirm_button@3x.png?1.0.17";